"use strict";
exports.__esModule = true;
exports.EMBED_CONGRATS_CONTENT = void 0;
exports.EMBED_CONGRATS_CONTENT = {
    BODY_1: 'Since you have Flex rent autopay turned off, you will need to manually initiate Flex to split your',
    BODY_2: 'rent. You can do this through your rent portal or the Flex app each month. ',
    CTA: 'Continue to split rent',
    HEADER: 'Your Flexible Rent account is set up!'
};
